const path = {
  ALL: '*',
  ROOT: '/',
  SIGNIN: '/sign-in',
  ORDER: '/order',
  CONTRACT: '/contract',
  ORDER_REPORT: '/order-report',
  PRODUCT_REPORT: '/product-report',
  CUSTOMER_REPORT: '/customer-report',
  OVERVIEW_REPORT: '/overview-report',
  PRODUCT: '/product',
  PRODUCT_SLOC: '/product-sloc',
  PRODUCT_DETAIL: '/product-detail',
  CUSTOMER: '/customer',
  USER: '/user',
  AVERAGE_ORDER: '/average-order',
  PROFILE: '/profile',
  SALE_LINE: '/sale-line',
  SALE_TEAM: '/sale-team',
  SALE_PLAN: '/sale-plan',
  HO_PLAN: '/ho-plan',
  HO_PLAN_DETAIL: '/ho-plan-detail',
  HO_FOLLOW_PLAN: '/ho-follow-plan',
  HO_FOLLOW_PLAN_DETAIL: '/ho-follow-plan-detail',
  CN_PLAN: '/cn-plan',
  CN_PLAN_DETAIL: '/cn-plan-detail',
  CN_FOLLOW_PLAN: '/cn-follow-plan',
  CN_FOLLOW_PLAN_DETAIL: '/cn-follow-plan-detail',
  TEAM_DASHBOARD: '/sale-plan/team-dashboard',
  SALELINETEAM: '/sale-line-team',
  PERMISSION: '/permission',
  UPDATEROLE: '/update-role',
  SALES_DEAL: '/sales-deal',
  SET_APPROVAL: '/set-approval',
  APPROVAL_DETAIL: '/approval-detail',
  ADD_APPROVAL: '/add-approval',
  EDIT_APPROVAL: '/edit-approval',
  GOLD_PRICE_MANAGEMENT: '/gold-price-management',
  APPROVE: '/approve',
  APPROVE_NEW_CUSTOMER: '/approve/approve-new-customer',
  APPROVE_PRICE_ORDER: '/approve/price-order',
  APPROVE_PRICE_PURCHASER: '/approve/price-purchaser',
  ROUTE_TRACKING: '/route-tracking',
  SALES_INVOICE: '/sales-invoice',
  SALES_INVOICE_DETAIL: '/sales-invoice-detail',
  PURCHASE_INVOICE: '/purchase-invoice',
  ADD_NEW_PURCHASE_INVOICE: '/add-new-purchase-invoice',
  // PURCHASE_INVOICE_DETAIL: '/purchase-invoice-detail',
  SEPARATE_PURCHASE_INVOICE_DETAIL: '/separate-purchase-invoice',
  PAYMENT_SUMMARY: '/payment-summary',
  PAYMENT_SUMMARY_DETAIL: '/payment-summary-detail',
  PAYMENT_SUMMARY_V2: '/payment-summary-v2',
  PAYMENT_SUMMARY_DETAIL_V2: '/payment-summary-detail-v2',
  PAYMENT_INFO: '/payment-info',
  EINVOICE_HISTORY: '/einvoice-history',
  REWARD_CALC: '/calc-reward',
  CALC_REWARD_SETUP: '/calc-reward-setup',
  GROSS_PROFIT: '/gross-profit',
  GROUP_ROLE: '/group-role',
  REWARD_INFO: '/reward-info',
  ROUTE_COST: '/route-cost',
  HANDOVER: '/handover',
  TEAM_REVENUE: '/team-revenue',
  CUSTOMER_REVENUE: '/customer-revenue',
  CUSTOMER_GROUP_REVENUE: '/customer-group-revenue',
  TEAM_SALE_REVENUE: '/team-sale-revenue',
  // transaction frequency
  TRANSACTION_FREQUENCY: '/transaction-frequency',
  // market coverage
  MARKET_COVERAGE: '/market-coverage',
  // sales line efficiency
  SALE_LINE_EFFICIENCY: '/sale-line-efficiency',

  // debt
  DEBT_LIMIT: '/debt/limit',
  DEBT_DMS: '/debt/dms',
  DEBT_DMS_DETAIL: '/debt/dms/detail',
  DEBT_DMS_CUSTOMER_DETAIL: '/debt/dms/customer-detail',

  // AML
  TERRORIST_LIST: '/terrorist-list',
  TERRORIST_VERIFICATION: '/terrorist-verification',

  // System Branch Config
  BRANCH_CONFIG: '/system/branch-config',
};

export default path;
